var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDevelopment)?_c('div',{staticClass:"dev-mode"},[_c('p',[_vm._v("Ambiente de homologação")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }